module.exports = __webpack_public_path__ + "img/layers.bdc46ad9.jpg";